"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var polished_1 = require("polished");
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("../../Themes/styled-components"));
var Wrapper = styled_components_1.default('span')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var Input = styled_components_1.default('input')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: ", ";\n  padding: 0;\n  margin: 0;\n  font-family: ", ";\n  &::placeholder {\n    color: ", ";\n  }\n"], ["\n  font-size: ", ";\n  padding: 0;\n  margin: 0;\n  font-family: ", ";\n  &::placeholder {\n    color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return polished_1.rem(theme.input.fontSize);
}, function (_a) {
    var theme = _a.theme;
    return theme.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.form.placeholderColor;
});
var MIN_WIDTH = 2;
exports.default = React.forwardRef(function (props, ref) {
    var value = props.value, onChange = props.onChange, placeholder = props.placeholder, _a = props.className, className = _a === void 0 ? '' : _a, restProps = __rest(props, ["value", "onChange", "placeholder", "className"]);
    var inputEl = React.useRef(null);
    var inputShadowEl = React.useRef(null);
    var inputPlaceholderShadowEl = React.useRef(null);
    var _b = React.useState(0), width = _b[0], setWidth = _b[1];
    React.useEffect(function () {
        if (inputPlaceholderShadowEl &&
            inputPlaceholderShadowEl.current &&
            inputShadowEl &&
            inputShadowEl.current) {
            var shadowWidth = inputShadowEl.current.getBoundingClientRect().width;
            var placeholderShadowWidth = inputPlaceholderShadowEl.current.getBoundingClientRect()
                .width;
            var targetWidth = shadowWidth;
            if (!value) {
                targetWidth = Math.max(shadowWidth, placeholderShadowWidth);
            }
            setWidth(targetWidth > MIN_WIDTH ? targetWidth + MIN_WIDTH : MIN_WIDTH);
        }
    }, [value, placeholder]);
    var inputStyles = {};
    if (inputEl && inputEl.current) {
        inputStyles = window.getComputedStyle(inputEl.current);
    }
    var styleCopy = {
        fontSize: inputStyles.fontSize,
        fontFamily: inputStyles.fontFamily,
        fontWeight: inputStyles.fontWeight,
        fontStyle: inputStyles.fontStyle,
        letterSpacing: inputStyles.letterSpacing,
        textTransform: inputStyles.textTransform,
        padding: inputStyles.padding,
        border: inputStyles.border,
        whiteSpace: 'pre',
        visibility: 'hidden',
        position: 'absolute',
    };
    return (React.createElement(Wrapper, null,
        React.createElement(Input, __assign({ value: value, ref: function (e) {
                if (ref) {
                    ref.current = e;
                }
                inputEl.current = e;
            }, style: {
                width: width + "px",
            }, className: className, onChange: function (e) {
                onChange(e.target.value);
            }, placeholder: placeholder }, restProps)),
        React.createElement("span", { ref: inputShadowEl, style: styleCopy, className: className }, value),
        React.createElement("span", { ref: inputPlaceholderShadowEl, style: styleCopy, className: className }, placeholder)));
});
var templateObject_1, templateObject_2;
